export default "__VITE_PUBLIC_ASSET__4e19b4d0__"